import React from 'react';
import OverlayPlay from './overlay-play';
import './overlay.scss';

const Overlay = (props) => {

    return (
        <div className="overlay">
            <img
                src={props.poster}
                alt={props.title}
            />
            <OverlayPlay onClick={props.onClick} />
        </div>
    );

};

export default Overlay;